// extracted by mini-css-extract-plugin
export default {"inline":"TmoFieldset_inline__WS9re"};